import { useQuery } from "react-query";
import { authAxios as axios, checkIsAgent } from "shared-auth";
import { config } from "../../../../../../config";
import PerformerType from "../../../../../../constants/PerformerType";
import { getAgentSearchRedirect } from "../helpers/getAgentSearchRedirect";

export interface IPerformer {
  forename: string;
  surname: string;
  performerType: string;
  viewPin: string;
}

export const unifyUrlsConfigs = (url: string) =>
  url.endsWith("/") ? url.slice(0, -1) : url;

export const cdSearchQueryKey = "cd-agent-performer-search";

export function useGetPerformerSearch(
  searchTerm: string,
  performerTypes?: PerformerType[],
  isLookingForRepresentation?: boolean
) {
  return useQuery([cdSearchQueryKey, searchTerm], {
    queryFn: async () => {
      const { data } = await axios.post<{
        profiles: IPerformer[];
        total: number;
      }>(`${unifyUrlsConfigs(config.searchAndFiltersApiUrl)}/search`, {
        IsLookingForRepresentation: isLookingForRepresentation,
        skip: 0,
        take: 11,
        performerName: searchTerm,
        performerTypes,
        orderBy: "Relevance",
      });

      return data.profiles.map((item) => ({
        name: `${item.forename} ${item.surname}`,
        data: {
          url: checkIsAgent()
            ? `${unifyUrlsConfigs(config.siteRootUrl)}${getAgentSearchRedirect(`${item.forename} ${item.surname}`)}?take=1`
            : `${unifyUrlsConfigs(config.siteRootUrl)}/${item.viewPin}`,
          type: item.performerType,
        },
      }));
    },
    enabled: !!searchTerm,
  });
}
